import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1,
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h1 style={{ 
        fontFamily: 'var(--font-serif)', 
        fontSize: '2.5rem', 
        fontWeight: '700',
        color: 'var(--color-text-main)',
        marginBottom: '1rem'
      }}>
        Page introuvable
      </h1>
      <p style={{ 
        fontSize: '1.1rem', 
        color: 'var(--color-text-light)', 
        marginBottom: '2.5rem',
        maxWidth: '600px',
        lineHeight: '1.6'
      }}>
        Désolé, la page que vous recherchez semble introuvable. Elle a peut-être été supprimée, renommée ou est temporairement indisponible.
      </p>
      <Link to="/" className="ny-home-btn ny-home-btn--primary">
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default ErrorPage;